import React from 'react'
import PropTypes from 'prop-types'

const TextCount = (props) => {
  return (
    <div className="opacity-50 flex items-center">
      <div>
        {props.textCount}/{props.maxLength}
      </div>
    </div>
  )
}

TextCount.propTypes = {
  textCount: PropTypes.number,
  maxLength: PropTypes.number,
}

export default React.memo(TextCount)
